import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-primary text-primary-foreground py-8">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          <div>
            <h3 className="font-bold text-lg mb-4">SmartLift Garage Doors</h3>
            <p className="text-primary-foreground/80">
              Professional garage door repairs, servicing, and automation across Berkshire, Hampshire & Surrey.
            </p>
          </div>
          <div>
            <h3 className="font-bold text-lg mb-4">Services</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/repairs" className="text-primary-foreground/80 hover:text-primary-foreground transition-colors">
                  Garage Door Repairs
                </Link>
              </li>
              <li>
                <Link to="/servicing" className="text-primary-foreground/80 hover:text-primary-foreground transition-colors">
                  Regular Servicing
                </Link>
              </li>
              <li>
                <Link to="/automation" className="text-primary-foreground/80 hover:text-primary-foreground transition-colors">
                  Door Automation
                </Link>
              </li>
              <li>
                <Link to="/smart-controller" className="text-primary-foreground/80 hover:text-primary-foreground transition-colors">
                  Smart Controllers
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-primary-foreground/80 hover:text-primary-foreground transition-colors">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/faqs" className="text-primary-foreground/80 hover:text-primary-foreground transition-colors">
                  FAQs
                </Link>
              </li>
              <li>
                <Link to="/privacy-policy" className="text-primary-foreground/80 hover:text-primary-foreground transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-primary-foreground/80 hover:text-primary-foreground transition-colors">
                  Terms & Conditions
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="font-bold text-lg mb-4">Areas Covered</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/berkshire" className="text-primary-foreground/80 hover:text-primary-foreground transition-colors">
                  Berkshire
                </Link>
              </li>
              <li>
                <Link to="/hampshire" className="text-primary-foreground/80 hover:text-primary-foreground transition-colors">
                  Hampshire
                </Link>
              </li>
              <li>
                <Link to="/surrey" className="text-primary-foreground/80 hover:text-primary-foreground transition-colors">
                  Surrey
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Service Areas - Town Links for SEO */}
        <div className="border-t border-primary-foreground/20 pt-8 mb-8">
          <h3 className="font-bold text-lg mb-6 text-center">Service Areas</h3>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-x-4 gap-y-2 text-sm">
            {[
              { name: "Garage Doors Reading", link: "/reading-garage-door-repairs" },
              { name: "Garage Doors Guildford", link: "/guildford-garage-door-repairs" },
              { name: "Garage Doors Southampton", link: "/southampton-garage-door-repairs" },
              { name: "Garage Doors Woking", link: "/woking-garage-door-repairs" },
              { name: "Garage Doors Basingstoke", link: "/basingstoke-garage-door-repairs" },
              { name: "Garage Doors Portsmouth", link: "/portsmouth-garage-door-repairs" },
              { name: "Garage Doors Farnham", link: "/farnham-garage-door-repairs" },
              { name: "Garage Doors Camberley", link: "/camberley-garage-door-repairs" },
              { name: "Garage Doors Bracknell", link: "/bracknell-garage-door-repairs" },
              { name: "Garage Doors Winchester", link: "/winchester-garage-door-repairs" },
              { name: "Garage Doors Maidenhead", link: "/maidenhead-garage-door-repairs" },
              { name: "Garage Doors Slough", link: "/slough-garage-door-repairs" },
              { name: "Garage Doors Windsor", link: "/windsor-garage-door-repairs" },
              { name: "Garage Doors Wokingham", link: "/wokingham-garage-door-repairs" },
              { name: "Garage Doors Newbury", link: "/newbury-garage-door-repairs" },
              { name: "Garage Doors Farnborough", link: "/farnborough-garage-door-repairs" },
              { name: "Garage Doors Fleet", link: "/fleet-garage-door-repairs" },
              { name: "Garage Doors Epsom", link: "/epsom-garage-door-repairs" },
              { name: "Garage Doors Dorking", link: "/dorking-garage-door-repairs" },
              { name: "Garage Doors Redhill", link: "/redhill-garage-door-repairs" },
              { name: "Garage Doors Cobham", link: "/cobham-garage-door-repairs" },
              { name: "Garage Doors Aldershot", link: "/aldershot-garage-door-repairs" },
              { name: "Garage Doors Eastleigh", link: "/eastleigh-garage-door-repairs" },
              { name: "Garage Doors Fareham", link: "/fareham-garage-door-repairs" },
            ].map((town) => (
              <Link
                key={town.name}
                to={town.link}
                className="text-primary-foreground/70 hover:text-primary-foreground transition-colors"
              >
                {town.name}
              </Link>
            ))}
          </div>
          <div>
            <h3 className="font-bold text-lg mb-4">Contact</h3>
            <ul className="space-y-2 text-primary-foreground/80">
              <li>
                <Link to="/contact" className="hover:text-primary-foreground transition-colors">
                  Contact Form
                </Link>
              </li>
              <li>
                <a href="tel:07836393815" className="hover:text-primary-foreground transition-colors">
                  07836 393815
                </a>
              </li>
              <li>
                <a href="mailto:office@smartliftgaragedoors.co.uk" className="hover:text-primary-foreground transition-colors">
                  office@smartliftgaragedoors.co.uk
                </a>
              </li>
              <li>24/7 Emergency Service</li>
              <li>
                <a href="https://maps.google.com/?cid=10431130324336682582" target="_blank" rel="noopener noreferrer" className="hover:text-primary-foreground transition-colors">
                  Read our Google reviews
                </a>
              </li>
              <li>
                <a href="https://search.google.com/local/writereview?placeid=ChIJ8y7pPzYqb6IRVqbkc8PRwpA" target="_blank" rel="noopener noreferrer" className="hover:text-primary-foreground transition-colors">
                  Leave us a Google review
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-primary-foreground/20 pt-6 text-center text-primary-foreground/80">
          <p>&copy; {new Date().getFullYear()} SmartLift Garage Doors. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
